module.exports = __webpack_public_path__ + "img/male.dcaaa945.svg";